<div class="dashboard-page">
  <!-- Header -->
  <div class="dashboard-header">
    <h1 class="app-title">FleetOperate</h1>
  </div>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Profile Section -->
    <div class="profile-card">
      <div class="profile-avatar">
        @if (!driverPicture) {
          <div class="avatar-placeholder">
            <mat-icon>person</mat-icon>
          </div>
        }
        @if (driverPicture) {
          <div class="avatar-image">
            <img [src]="driverPicture" alt="Driver Photo" />
          </div>
        }
      </div>
      <h2 class="driver-name">{{ driverName }}</h2>
    </div>

    <!-- Stats Grid -->
    @if (completed || upcoming || responseRate || earnedThisMonth) {
      <div class="stats-grid">
        @if (completed) {
          <div class="stat-card">
            <div class="stat-value">{{ completed }}</div>
            <div class="stat-label">Completed</div>
          </div>
        }
        @if (upcoming) {
          <div class="stat-card">
            <div class="stat-value">{{ upcoming }}</div>
            <div class="stat-label">Upcoming</div>
          </div>
        }
        @if (responseRate) {
          <div class="stat-card">
            <div class="stat-value">{{ responseRate }}</div>
            <div class="stat-label">Response Rate</div>
          </div>
        }
        @if (earnedThisMonth) {
          <div class="stat-card highlight">
            <div class="stat-value">{{ earnedThisMonth }}</div>
            <div class="stat-label">Earned This Month</div>
          </div>
        }
      </div>
    }

    <!-- Profile Completion Notice -->
    @if (!profileCompleted) {
      <div class="completion-notice">
        <mat-icon class="notice-icon">info_outline</mat-icon>
        <span class="notice-text" (click)="onNavigateToProfile()" data-test="complete-profile-link">
          Complete your profile to get your first assignment
        </span>
      </div>
    }
  </div>
</div>